<div class="d-flex d-sm-flex flex-wrap" [ngClass]="!article.single_article_code ? 'noSelection' : ''">
  @if (article.temporarily_undeliverable || modelTemporarilyUndeliverable) {
    <span class="d-block text-danger w-100">
      {{"TEMPORARILY_UNDELIVERABLE"|translate}}
    </span>
  }
  @for (option of article.matrix.options; track option) {
    <div class="d-inline-block" [ngClass]="[
        option.value.length > 1 ? 'w-100' : '',
        option.value.length >= 5 && article.matrix.options.length > 1
          ? 'long'
          : ''
      ]">
      @if (article.matrix.options.length > 1 && option.value.length > 1) {
        <label class="d-block mt-2">{{
        option.description }}</label>
      }
      <div class="d-flex flex-wrap">
        @for (optionArticle of option.value; track optionArticle) {
          <button [style.display]="optionArticle.enabled ? '' : 'none'"
            class="btn btn-default articleRowLabel align-items-center" placement="top" ngbTooltip="{{
              (optionArticle | statusText : false : false) +
                ' - ' +
                ('ARTICLE_NO' | translate) +
                ' ' +
                optionArticle.single_article_code
            }}" [ngClass]="[
              optionArticle.single_article_code === article.single_article_code
                ? 'btn-default selected'
                : 'btn-default',
              'status_' + optionArticle.stock_status,
              'stockweek_' + optionArticle.stock_week,
              'company_' + article.company_id,
              optionArticle.enabled ? 'd-inline-flex' : 'd-none'
            ]" (click)="selectArticle(optionArticle)">
            {{
            option.value.length > 1 ? optionArticle.value : option.description
            }}
            <i></i>
          </button>
        }
      </div>
    </div>
  }
  <div class="d-inline-flex">
    <i class="material-icons d-inline-flex align-items-center clickable withOpacity expander"
    (click)="expand = !expand"> {{expand?"expand_less":"expand_more"}}</i>
  </div>
  @if (expand) {
    <table class="table table-striped mt-2 stock-list w-100 border bg-white overview-table">
      @for (option of article.matrix.options; track option) {
        <tr class="px-2 clickable">
          @for (optionArticle of option.value; track optionArticle) {
            <td class="ps-2" (click)="selectArticle(optionArticle)" [ngClass]="[
            optionArticle.single_article_code === article.single_article_code
              ? 'fw-bold'
              : '']">{{
            option.description }}</td>
            <td (click)="selectArticle(optionArticle)" [ngClass]="[
              optionArticle.single_article_code === article.single_article_code
                ? 'fw-bold'
                : '']">
              {{
              optionArticle.single_article_code
            }}</td>
            <td (click)="selectArticle(optionArticle)" [ngClass]="[
            optionArticle.single_article_code === article.single_article_code
              ? 'fw-bold'
              : '']">{{
            (optionArticle | statusText : false : false)}}</td>
          }
        </tr>
      }
    </table>
  }
</div>
